import { GroupScore } from "../generated-api-proxy";

export class GroupScoreViewModel {
  group!: number;
  score!: number;
  category: string;

  constructor(groupScore: GroupScore, category: string) {
    this.group = groupScore.group;
    this.score = groupScore.score;
    this.category = category;
  }

  static empty(): GroupScoreViewModel {
    return new GroupScoreViewModel(new GroupScore(), "null");
  }
}
